@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.header {
    border-bottom: 1px solid var(--color-black);
    padding: 30px 0;
}

.footer {
    padding: 30px 0;
}

.event {
    align-items: center;
    border-bottom: 1px solid var(--color-black);
    column-gap: 59px;
    display: grid;
    grid-template-columns: 108px 1fr;
    padding: 30px 0;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        align-items: flex-start;
        grid-template-columns: 10vw 1fr;
    }

    & picture {
        display: flex;
        justify-content: center;
    }

    & img {
        max-height: 150px;
    }
}

.year {
    color: var(--color-lobster);
    font-size: 3.75rem;
    letter-spacing: -0.08em;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        font-size: 7vw;
    }
}
